module.exports = __webpack_public_path__ + "assets/pure-css.0d61aec5.svg";